import React from "react";
import HeaderImg from "../../../Assets/ISO Certification/ISOBanner.png";

const ISOHeader29990 = () => {
  return (
    <>
      <div className="w-full h-auto relative">
        <img
          src={HeaderImg}
          alt="ISO Certification Banner"
          className="object-cover w-full h-40 sm:h-48 md:h-52 lg:h-full"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-white text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium">
            ISO 29990:2010
          </p>
        </div>
      </div>
    </>
  );
};

export default ISOHeader29990;
